var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-results-wrapper flex-container flex-dir-column align-middle"},[_c('img',{attrs:{"src":require("@/assets/svg/icon-no-results.svg"),"alt":""}}),_vm._v(" "),_c('p',[_vm._t("default",[_c('translate',[_vm._v("No results to display at the moment.")])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a51d4998","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--1-1!./src/components/utils/BmrNoResults.vue
// module id = null
// module chunks = 